import { JWT_KEY, MY_DOCK_URL_KEY } from "Auth/Models/AuthConstants";
import type { ApiQueryMeta } from "Infrastructure/Api/ApiUtils";
import {
	getApiV1AuthUserinfoQueryKey,
	postApiV1AuthBrokerSignInMutation,
} from "Infrastructure/Api/generated/@tanstack/react-query.gen";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useBrokerSignInMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		...postApiV1AuthBrokerSignInMutation(),
		// Errors are surfaced inline by BrokerAuthPage; suppress the global toast.
		meta: { showError: false } satisfies ApiQueryMeta,
		onSuccess: (data) => {
			localStorage.setItem(JWT_KEY, `Bearer ${data.userInfo.token}`);

			if (data.userInfo.myDockUrl) {
				localStorage.setItem(MY_DOCK_URL_KEY, data.userInfo.myDockUrl);
			} else {
				localStorage.removeItem(MY_DOCK_URL_KEY);
			}

			queryClient.invalidateQueries({
				queryKey: getApiV1AuthUserinfoQueryKey(),
			});
		},
	});
}
